'use client';

import { statusTypes, usePollingStore } from '../lib/pollingStore.js';
import Icon, { ICON_TYPE } from '../components/base/icon.js';
import Tooltip from 'components/rich/tooltip.js';

export const RecordsBadge = ({ editorItem }) => {
  const status = usePollingStore(state => state.status);
  const pollingData = usePollingStore(state => state.data);

  // Use polling store if available, fallback to draft data
  const citationsCount = status === statusTypes.SUCCESS
    ? pollingData?.CitationsCount
    : editorItem?.additionalInfo?.CitationsCount;

  if (citationsCount > 0) {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip text="We found some records that you can use in your book.">
          <Icon type={ICON_TYPE.LEAF} width={25} height={25} />
        </Tooltip>
      </div>
    );
  }

  return null;
}
